import React from 'react';
import ReportingPageLayout from './ReportingPageLayout';
import useReportingPage from '../hooks/useReportingPage';

const REPORTS = [
  {
    key: 'classes_sales',
    title: 'Class Sales',
    description: 'Every class with its registrations, comps, gross, fees, refunds, and net — net matches your dashboard\'s Classes revenue.',
    path: (teamId) => `/teams/${teamId}/reporting/classes/sales`,
  },
  {
    key: 'classes_registrations',
    title: 'Registrations',
    description: 'One row per attendee: who registered for which class, what they paid, and whether it was refunded.',
    path: (teamId) => `/teams/${teamId}/reporting/classes/registrations`,
  },
];

function ReportingClassesPage({ team }) {
  const {
    isMobile, sidebarOpen, setSidebarOpen,
    dateRange, setDateRange,
    filterSidebarOpen, setFilterSidebarOpen,
    activeFilters,
    handleFilterChange, handleRemoveFilter, handleClearAllFilters,
  } = useReportingPage('year_to_date');

  const teamId = team?.id;

  return (
    <ReportingPageLayout
      team={team}
      activeKey="classes"
      title="Classes"
      subtitle="Sales and registration reports for your classes."
      dateRange={dateRange}
      setDateRange={setDateRange}
      isMobile={isMobile}
      sidebarOpen={sidebarOpen}
      setSidebarOpen={setSidebarOpen}
      filterSidebarOpen={filterSidebarOpen}
      setFilterSidebarOpen={setFilterSidebarOpen}
      activeFilters={activeFilters}
      filterGroups={[]}
      handleFilterChange={handleFilterChange}
      handleRemoveFilter={handleRemoveFilter}
      handleClearAllFilters={handleClearAllFilters}
      showDatePicker={false}
      showFilters={false}
    >
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fill, minmax(280px, 1fr))',
          gap: 16,
        }}
      >
        {REPORTS.map((report) => (
          <a
            key={report.key}
            href={teamId ? report.path(teamId) : '#'}
            className="text-decoration-none d-block"
            style={{ background: 'var(--sl-bg-primary, #fff)', border: '1px solid var(--sl-border-secondary, #e4e7ec)', borderRadius: 8, padding: 20, color: 'inherit' }}
          >
            <div style={{ fontWeight: 700, fontSize: 16, color: 'var(--sl-text-primary, #101828)', marginBottom: 6 }}>
              {report.title}
            </div>
            <div style={{ fontSize: 13, color: 'var(--sl-text-quaternary, #667085)', lineHeight: 1.5 }}>
              {report.description}
            </div>
          </a>
        ))}
      </div>
    </ReportingPageLayout>
  );
}

export default ReportingClassesPage;
